import { ApiClient } from 'app/service/api-service'
import { ColumnEndPoint } from './constant'
import {
  IPayloadCreateActivityEvent,
  IPayloadUpdateActivityEvent,
} from './model'
export const requestPostCreateActivityEvent = (
  body: IPayloadCreateActivityEvent,
) =>
  ApiClient.Post({
    url: ColumnEndPoint.CREATE,
    body,
  })

export const requestUpdateActivityEvent = (body: IPayloadUpdateActivityEvent) =>
  ApiClient.Put({
    url: ColumnEndPoint.UPDATE,
    body,
  })

export const requestGetColumnActivity = (activityId: number) =>
  ApiClient.Post({
    url: ColumnEndPoint.GET_BY_ACTIVITY_ID,
    body: { activityId },
  })

export const requestDeleteActivityEvent = (id: number) =>
  ApiClient.Put({
    url: ColumnEndPoint.DELETE,
    body: { id },
  })
